import config from "environment";
import { getRequest, postRequest } from "./client";

import { Snippet } from "winslow-core";
import {
  apiCreateSnippetPayload,
  apiUpdateSnippetPayload,
} from "./SnippetService.types";
import { AIResponse } from "./AIService";

const { baseApi } = config;

export async function apiCreateSnippet(
  payload: apiCreateSnippetPayload
): Promise<Snippet | null> {
  const fetchURL = `${baseApi}/snippets/create`;
  console.log("[apiCreateSnippet] payload: ", payload);
  return await postRequest(fetchURL, payload, "API/apiCreateSnippet");
}

export async function apiUpdateSnippet(
  snippetId: string,
  payload: apiUpdateSnippetPayload
): Promise<Snippet | null> {
  const fetchURL = `${baseApi}/snippets/update/${snippetId}`;
  console.log("[apiUpdateSnippet] snippetId: ", snippetId);
  console.log("[apiUpdateSnippet] payload: ", payload);
  return await postRequest(fetchURL, payload, "API/apiUpdateSnippet");
}

// for a user in  workspace
export async function apiDeleteSnippet(
  snippetId: string
): Promise<Snippet | null> {
  const fetchURL = `${baseApi}/snippets/delete/${snippetId}`;
  return await getRequest(fetchURL, "API/apiDeleteSnippet");
}

export async function apiLongerShorter(
  longerShorter: "longer" | "shorter",
  answer: string
): Promise<string | null> {
  const fetchURL = `${baseApi}/ai/longer-shorter`;

  return await postRequest(
    fetchURL,
    {
      longerShorter,
      answer,
    },
    "API/apiLongerShorter"
  );
}
